import InjuryLayout from "@/app/(app)/(crew)/reports/(injury)/_layout";

export default InjuryLayout;
